<template>
  <sweet-modal
    ref="modal"
    @class="vld - parent"
    @close="resetShowTestModal"
    hide-close-button
    :icon="icon"
  >
    <div v-if="unsavedTemplate">
      <p id="unsavedTemplateError">{{ $t('test.missing_template_errror') }}</p>
    </div>
    <div v-else>
      <div v-if="immediateDeliveryPresent === 'TRUE'">
        <div slot="title" id="modal-title">
          <strong>{{ $t('test.title') }}</strong>
        </div>
        <div>
          <div class="row">
            <div class="col-md-12 left">
              <div class="form-group">
                <label for="subject">{{ $t('test.subject') }}</label>
                <input
                  type="text"
                  class="form-control validated-field"
                  v-model="subject"
                  id="subject"
                />
                <span
                  v-for="e in fieldErrors.subject"
                  :key="e"
                  class="err subject-error"
                  >{{ e }}</span
                >
                <form-validation-error
                  :validationErrors="validationErrors"
                  :jsonPath="'/message/subject'"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 left">
              <div class="form-group">
                <label for="sender">{{ $t('test.sender') }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="sender"
                  id="sender"
                  placeholder="Mario Rossi"
                />
                <span
                  v-for="e in fieldErrors.sender"
                  :key="e"
                  class="err sender-error"
                  >{{ e }}</span
                >
                <form-validation-error
                  :validationErrors="validationErrors"
                  :jsonPath="'/sender/fromName'"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 left">
              <div class="form-group">
                <label for="mailFrom">{{ $t('test.mail_from') }}</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="mailFrom"
                  id="mailFrom"
                  placeholder="mario@example.com"
                />
                <span
                  v-for="e in fieldErrors.mailFrom"
                  :key="e"
                  class="err mailfrom-error"
                  >{{ e }}</span
                >
                <form-validation-error
                  :validationErrors="validationErrors"
                  jsonPath="/sender/from"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 left">
              <div class="form-group">
                <label for="replyTo">{{ $t('test.reply_to') }}</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="replyTo"
                  id="replyTo"
                  placeholder="mario@example.com"
                />
                <span
                  v-for="e in fieldErrors.replyTo"
                  :key="e"
                  class="err replyto-error"
                  >{{ e }}</span
                >
                <form-validation-error
                  :validationErrors="validationErrors"
                  :jsonPath="'/sender/replyTo'"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 left">
              <div class="form-group">
                <label for="recipient">{{ $t('test.recipient') }}</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="recipient"
                  id="recipient"
                  placeholder="giorgio@example.com"
                />
                <button class="add btn btn-primary" @click="addRecipient">
                  +
                </button>
                <span v-if="invalidRecipient" class="err recipient-error">{{
                  $t('test.invalid_email_address')
                }}</span>
                <span v-if="duplicateRecipient" class="err">{{
                  $t('test.duplicate_recipient_error')
                }}</span>
                <span v-if="maxRecipients" class="err">{{
                  $t('test.max_recipient_error')
                }}</span>
                <span v-if="emptyRecipients" id="emptyRecipients" class="err">{{
                  $t('test.empty_recipients_error')
                }}</span>
                <div v-for="(r, index) in recipients" :key="r" class="top-spc">
                  <p :id="'recipient_' + index" class="recipient-list">
                    <button class="btn btn-danger" @click="removeRecipient(r)">
                      X
                    </button>
                    {{ r }}
                  </p>
                  <form-validation-error
                    :validationErrors="validationErrors"
                    :jsonPath="
                      index > 0
                        ? '/immediateOptions/ccRecipients/' + (index - 1)
                        : '/subscriber/RECIPIENT'
                    "
                    class="recipient-errors"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 left">
              <div class="form-group">
                <label for="mergeTag">Merge Tag</label>
                <div class="row">
                  <div class="col-md-5">
                    <input
                      v-if="mergeTags.length === 0"
                      type="text"
                      class="form-control"
                      v-model="mergeTag"
                      id="mergeTag"
                      placeholder="Tag Name"
                    />
                    <select v-else class="form-control" v-model="mergeTag">
                      <option
                        v-for="m in mergeTags"
                        :key="m.name"
                        :value="m.name"
                      >
                        {{ m.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-1">=</div>
                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="mergeValue"
                      id="mergeValue"
                      placeholder="Tag Value"
                    />
                  </div>
                </div>
                <button class="add btn btn-primary" @click="addMergeTag">
                  +
                </button>
                <span v-if="duplicateTag" class="err">{{
                  $t('test.duplicate_merge_tag_error')
                }}</span>
                <div v-for="t in tags" :key="t.mergeTag" class="top-spc">
                  <button class="btn btn-danger" @click="removeMergeTag(t)">
                    X
                  </button>
                  <strong>{{ t.mergeTag }} =</strong>
                  {{ t.mergeValue }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="button">
          <button class="btn btn-primary" @click="send">
            {{ $t('test.send') }}
          </button>
        </div>
      </div>
      <div v-else-if="immediateDeliveryPresent === 'FALSE'">
        <p id="missingImmediate">
          {{ $t('test.missing_immediate_error') }}
          <span style="white-space: nowrap">
            {{ $t('test.missing_immediate_alias') }}
          </span>
          <a :href="$t('test.missing_immediate_link')" target="blank">{{
            $t('test.missing_immediate_link_name')
          }}</a>
          {{ $t('test.missing_immediate_error_after') }}
        </p>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import FormValidationError from '../FormValidationError.vue';
import moment from 'moment';

const retrieveSavedData = templateId => {
  const savedData = localStorage.getItem(templateId);
  if (savedData === null) {
    return {};
  }
  return JSON.parse(savedData);
};

const saveData = that => {
  const formData = {
    version: 1,
    sender: that.sender,
    mailFrom: that.mailFrom,
    replyTo: that.replyTo,
    tags: that.tags,
    recipients: that.recipients
  };

  localStorage.setItem(that.templateData.id, JSON.stringify(formData));
};

export default {
  name: 'SendTestModal',
  components: {
    SweetModal,
    FormValidationError
  },
  props: {
    sendClient: Object
  },
  data: function () {
    return {
      subject: '',
      sender: '',
      mailFrom: '',
      replyTo: '',
      recipient: '',
      recipients: [],
      mergeTag: '',
      mergeValue: '',
      tags: [],
      duplicateRecipient: false,
      maxRecipients: false,
      duplicateTag: false,
      mergeTags: [],
      validationErrors: [],
      emptyRecipients: false,
      invalidRecipient: false,
      fieldErrors: {
        subject: [],
        sender: [],
        mailFrom: [],
        replyTo: []
      },
      immediateDelivery: undefined,
      immediateDeliveryPresent: 'UNKOWN',
      unsavedTemplate: false,
      icon: ''
    };
  },
  computed: mapState({
    showTestModal: state => state.showTestModal,
    templateData: state => state.templateData,
    customer: state => state.customer,
    accessToken: state => state.accessToken,
    htmlTest: state => state.htmlTest
  }),
  methods: {
    resetShowTestModal: function () {
      this.setShowTestModal(false);
    },
    resetData: function () {
      this.mergeTags =
        this.templateData.conf.mergeTags !== undefined
          ? this.templateData.conf.mergeTags
          : [];
      let templateName = '';
      if (this.templateData.name === undefined) {
        this.unsavedTemplate = true;
      } else {
        this.unsavedTemplate = false;
        templateName = this.templateData.name;
      }
      const savedData = retrieveSavedData(this.templateData.id);
      const now = moment().format('YYYY-MM-DD HH:m:s');
      this.subject = `Test - ${templateName} - ${now}`;
      this.sender = savedData.sender || '';
      this.mailFrom = savedData.mailFrom || '';
      this.replyTo = savedData.replyTo || '';
      this.recipient = '';
      this.recipients = savedData.recipients || [];
      this.mergeTag = '';
      this.mergeValue = '';
      this.tags = savedData.tags || [];
      this.initializeErrors();
      this.duplicateRecipient = false;
      this.maxRecipients = false;
      this.emptyRecipients = false;
      this.invalidRecipient = false;
      this.immediateDeliveryPresent = 'UNKOWN';
      this.sendClient
        .getTestDelivery(this.accessToken, this.customer)
        .then(result => {
          this.immediateDelivery = result;
          if (result === undefined) {
            this.immediateDeliveryPresent = 'FALSE';
            this.icon = 'warning';
          } else {
            this.immediateDeliveryPresent = 'TRUE';
            this.icon = '';
          }
        })
        .catch(error => this.setError(error));
    },
    addRecipient: function () {
      this.emptyRecipients = false;
      this.duplicateRecipient = false;
      this.maxRecipients = false;
      if (this.recipient === '') {
        return;
      }
      this.invalidRecipient = !this.isValidEmailAddress(this.recipient);
      if (this.invalidRecipient) {
        return;
      }
      if (this.recipients.length === 10) {
        this.maxRecipients = true;
        return;
      }
      if (!this.recipients.includes(this.recipient)) {
        this.duplicateRecipient = false;
        this.maxRecipients = false;
        this.recipients.push(this.recipient);
        this.recipient = '';
      } else {
        this.duplicateRecipient = true;
      }
    },
    removeRecipient: function (recipient) {
      this.duplicateRecipient = false;
      this.maxRecipients = false;
      this.recipients = this.recipients.filter(e => e !== recipient);
    },
    addMergeTag: function () {
      if (this.mergeTag === '') return;
      const element = {
        mergeTag: this.mergeTag,
        mergeValue: this.mergeValue
      };
      const filtered = this.tags.filter(t => t.mergeTag === this.mergeTag);
      if (filtered.length === 0) {
        this.duplicateTag = false;
        this.tags.push(element);
        this.mergeTag = '';
        this.mergeValue = '';
      } else {
        this.duplicateTag = true;
      }
    },
    removeMergeTag: function (mergeTag) {
      this.duplicateTag = false;
      this.tags = this.tags.filter(e => e !== mergeTag);
    },
    initializeErrors: function () {
      this.fieldErrors = {
        subject: [],
        sender: [],
        mailFrom: [],
        replyTo: []
      };
      this.invalidRecipient = false;
    },
    validateFields: function () {
      if (this.subject == null || this.subject.trim() === '')
        this.fieldErrors.subject.push(this.$t('test.empty_subject_error'));
      if (this.sender === '')
        this.fieldErrors.sender.push(this.$t('test.empty_sender_error'));
      const emptyMailFrom = this.mailFrom === '';
      if (emptyMailFrom) {
        this.fieldErrors.mailFrom.push(this.$t('test.empty_mail_from_error'));
      } else if (!this.isValidEmailAddress(this.mailFrom)) {
        this.fieldErrors.mailFrom.push(this.$t('test.invalid_email_address'));
      }
      const emptyReplyTo = this.replyTo === '';
      if (emptyReplyTo) {
        this.fieldErrors.replyTo.push(this.$t('test.empty_reply_to_error'));
      } else if (!this.isValidEmailAddress(this.replyTo)) {
        this.fieldErrors.replyTo.push(this.$t('test.invalid_email_address'));
      }
    },
    isValidEmailAddress: function (value) {
      return /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z]{2,}$/.test(value);
    },
    ...mapMutations([
      'setShowTestModal',
      'setError',
      'setSuccess',
      'setCustomMessage'
    ]),
    send: async function () {
      this.setSuccess(false);
      this.initializeErrors();
      this.validateFields();

      this.emptyRecipients = this.recipients.length === 0;

      const hasError =
        this.fieldErrors.subject.length > 0 ||
        this.fieldErrors.sender.length > 0 ||
        this.fieldErrors.mailFrom.length > 0 ||
        this.fieldErrors.replyTo.length > 0 ||
        this.emptyRecipients;

      if (hasError) {
        return;
      }

      try {
        const extraInfo = {
          emailDesignerTemplateId: this.templateData.id
        };

        const payload = {};
        payload.alias = this.immediateDelivery.alias;
        payload.message = {};
        payload.message.subject = this.subject;
        payload.message.body = this.htmlTest;
        payload.sender = {};
        payload.sender.fromName = this.sender;
        payload.sender.from = this.mailFrom;
        payload.sender.replyTo = this.replyTo;
        payload.includeAttachments = false;
        const tagsObject = this.tags.reduce(
          (a, v) => ({...a, [v.mergeTag]: v.mergeValue}),
          {}
        );
        payload.subscriber = {RECIPIENT: this.recipients[0], ...tagsObject};
        payload.immediateOptions = {};
        payload.immediateOptions.ccRecipients = this.recipients.slice(1);

        this.validationErrors = [];
        const response = await this.sendClient.sendMessage(
          this.accessToken,
          this.customer,
          payload,
          extraInfo
        );
        this.setCustomMessage(this.$t('test.test_sent', [response.data.uuid]));

        saveData(this);

        this.$refs.modal.close();
        this.setSuccess(true);
      } catch (error) {
        if (error.errors != null) {
          this.validationErrors = error.errors;
        }
        this.setError(error);
      }
    }
  },
  watch: {
    showTestModal: function (newValue) {
      if (newValue === true) {
        this.resetData();
        this.$refs.modal.open();
      }
    }
  }
};
</script>

<style scoped>
.left {
  text-align: left;
}
.add {
  margin-top: 0.5em;
}
.top-spc {
  margin-top: 0.5em;
}

.top-spc .btn {
  margin-right: 0.5em;
}

.err {
  color: red;
  margin-left: 0.5em;
}

.recipient-errors {
  padding-left: 41px;
}

.recipient-list {
  margin-bottom: 0px;
}
</style>
